import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/images/left.png';
import _imports_1 from '../../../assets/images/right.png';

const _withScopeId = n => (_pushScopeId("data-v-679f81ef"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "ExcitingClassroom"
};
const _hoisted_2 = {
  key: 0,
  class: "swiper-box"
};
const _hoisted_3 = {
  class: "swiper-content3"
};
const _hoisted_4 = {
  class: "video-cover"
};
const _hoisted_5 = {
  class: "video-cover-img"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 0,
  class: "video-time"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "play-icon"
}, null, -1));

const _hoisted_9 = {
  class: "top-info"
};
const _hoisted_10 = {
  class: "video-title"
};
const _hoisted_11 = {
  class: "video-info"
};
const _hoisted_12 = {
  class: "teacher-icon"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "teacher-name"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, "|", -1));

const _hoisted_16 = {
  class: "teacher-org"
};
const _hoisted_17 = {
  class: "video-schedule"
};

const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"custom-nav\" data-v-679f81ef><button class=\"custom-prev\" data-v-679f81ef><img src=\"" + _imports_0 + "\" alt=\"\" data-v-679f81ef></button><button class=\"custom-next\" data-v-679f81ef><img src=\"" + _imports_1 + "\" alt=\"\" data-v-679f81ef></button></div>", 1);

const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = {
  class: "no-data"
};
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import SwiperCore, { Navigation, A11y, Autoplay, Pagination, EffectCoverflow } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import VideoDialog from '@/pages/components/FilePreview/VideoDialog.vue';
import UserCard from './UserCard/index.vue';
import { dateTransfer } from '@/plugins/utils';
import { Empty } from 'zhs-components';
import CommonTitle from './CommonTitle.vue';
export default {
  props: {
    userInfo: {
      type: Object,
      default: null
    },
    zhsRole: {
      type: Number || String,
      default: 0
    },
    menu: {
      type: Object,
      default: null
    }
  },
  emits: ['updateZhsRole'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    SwiperCore.use([Navigation, A11y, Autoplay, Pagination, EffectCoverflow]);
    const modules = [Navigation, A11y, Autoplay, Pagination, EffectCoverflow];
    const $http = inject('$http');
    const courseList = ref([]);

    const getCourseList = async () => {
      const res = await $http.getWonderfulClassListApi({
        menuId: props.menu.menu_id,
        num: props.menu.num
      });
      console.log(2222, res);
      courseList.value = res.list;
      console.log('courseList', courseList.value);
    };

    getCourseList();

    const updateZhsRole = val => {
      emits('updateZhsRole', val);
    };

    const showVideoDialog = ref(false);
    const videoInfo = reactive({
      url: '',
      title: ''
    });

    const handleDetail = item => {
      videoInfo.url = item.fileUrl;
      videoInfo.title = item.courseName;
      console.log(videoInfo);
      showVideoDialog.value = true;
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(CommonTitle, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.menu && __props.menu.module_name || '精彩课堂'), 1)]),
        _: 1
      }), courseList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_unref(Swiper), {
        watchSlidesProgress: true,
        slidesPerView: "5",
        spaceBetween: 16,
        loop: courseList.value.length > 5,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.custom-next',
          prevEl: '.custom-prev'
        },
        modules: modules,
        class: "swiper-content"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList.value, (item, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            class: "swiper-slide",
            key: index,
            onClick: $event => handleDetail(item)
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
              src: item.cover || require('@/assets/images/video-cover.png'),
              alt: ""
            }, null, 8, _hoisted_6)]), item.liveDuration ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(dateTransfer)(item.liveDuration)), 1)) : _createCommentVNode("", true), _hoisted_8]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(item.courseName), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
              src: item.avatar || require('@/assets/images/common/teacher_icon.png'),
              alt: ""
            }, null, 8, _hoisted_13)]), _createElementVNode("div", _hoisted_14, _toDisplayString(item.teacherName), 1), _hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString(item.kkxy), 1)]), _createElementVNode("div", _hoisted_17, _toDisplayString(item.stime) + "-" + _toDisplayString(item.endTime), 1)])]),
            _: 2
          }, 1032, ["onClick"]);
        }), 128))]),
        _: 1
      }, 8, ["loop", "navigation"]), _hoisted_18])) : (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_unref(Empty))])]))]), _createVNode(VideoDialog, {
        show: showVideoDialog.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => showVideoDialog.value = $event),
        videoInfo: _unref(videoInfo)
      }, null, 8, ["show", "videoInfo"])], 64);
    };
  }

};